import { render } from "./index.vue?vue&type=template&id=08d5dce0&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=08d5dce0&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/carbon-rating-admin-site-CI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d5dce0"]])

export default __exports__